import { CommentsCount } from "@/components/comments/CommentsCount.tsx";
import { FormAggregatedResultElementProps } from "@/components/form-result/aggregated-result/components/types.ts";
import { ResultFiles } from "@/components/form-result/result-modal/components/FileElementResult.tsx";
import { Box, Stack, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { EmployeeItem } from "@/components/employee/EmployeeItem.tsx";

export const FormAggregatedResultFileElement = ({
  element,
  result,
  showDetailModalCallback,
}: FormAggregatedResultElementProps) => {
  const { t } = useTranslation();
  const settings = element.file_settings;
  const fileData = result?.file_data;

  if (!settings) return null;

  return (
    <Stack
      className={twMerge("flex-1", showDetailModalCallback ? "cursor-pointer" : undefined)}
      onClick={showDetailModalCallback ? () => showDetailModalCallback(element) : undefined}
      gap={"md"}
    >
      <Title
        header={settings.title || t("surveys:question_type_file")}
        size="sm"
        className={twMerge(
          "wrap-break-word overflow-hidden",
          settings.title ? "" : "text-secondary"
        )}
        required={settings.is_required}
      />
      {fileData && (
        <Stack gap="md">
          <Text className="font-semibold">
            {t("plurals:responses_count", { count: fileData.total_answers })}
          </Text>

          {fileData.comments_count > 0 && (
            <CommentsCount
              totalComments={fileData.comments_count}
              commentersPreview={fileData.commenters_preview ?? []}
            />
          )}
          {fileData.answer_previews.map((answer, index) => (
            <Box variant={"border"} key={`${answer.employee?.id ?? "anonymous"}-${index}`}>
              <Stack gap="md">
                {answer.employee && (
                  <EmployeeItem
                    employee={answer.employee}
                    direction={"horizontal"}
                    size={"sm"}
                    variant={"secondary"}
                  />
                )}
                <ResultFiles files={answer.files} />
              </Stack>
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
